module.exports = __webpack_public_path__ + "static/sport/tag-login-active.8e1706f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport8/tag-login-active.png
// module id = G4wL
// module chunks = 0